/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Validation_Invalid_Totp_CodeInputs */



/**
* | output |
* | --- |
* | "Enter the 6-digit code from your authenticator app." |
*
* @param {Form_Validation_Invalid_Totp_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_invalid_totp_code = /** @type {((inputs?: Form_Validation_Invalid_Totp_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Invalid_Totp_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte gib den 6-stelligen Code aus deiner Authenticator-App ein.")
	return /** @type {LocalizedString} */ ("Enter the 6-digit code from your authenticator app.")
});